import { Injectable } from '@angular/core';
import { App, AlertController, ToastController, PopoverController, Platform, Events } from 'ionic-angular';
import { Storage } from '@ionic/storage';
import { TranslateService } from '@ngx-translate/core';
import CryptoJS from 'crypto-js';
//import { IMG_ENDPOINT } from '../../environments/environment';
declare var SERVICE_ID;
declare let window: any;
declare let navigator: any;

@Injectable()
export class CommonProvider {

  constructor(
    public app: App,
    public storage: Storage,
    public alertCtrl: AlertController,
    public toastCtrl: ToastController,
    public popoverCtrl: PopoverController,
    public platform: Platform,
    public events: Events,
    public translate: TranslateService,
  ) {}

  checkLogin(navCtrl) {
    let is_login = this.isLogin();
    if (is_login) {
      return true;
    }

    if (this.isApp()) {
      navCtrl.setRoot('ErrorPage',{message:'アプリを起動し直してください。'});
    } else {
      this.logout();
      if (this.isPwaAccount()) {
        navCtrl.setRoot('LoginPage');
      } else {
        navCtrl.setRoot('home');
      }
    }
  }

  isGoLogin(page_name) {
    if (this.isApp()) {
      return true;
    }

    let pages = [
                  'InfoIndexPage',
                  //'StampIndexPage'
                ];
    if (pages.indexOf(page_name) == -1){
      return true;
    }

    if (this.isLogin()) {
      return true;
    }

    return false;
  }

  isLogin() {
    let is_login:boolean = false;

    let token = localStorage.getItem('token');
    let user_data = this.getUser();
    if (token && user_data['id']) {
      is_login = true;
    }
    return is_login;
  }

  logout() {
    if (this.isApp()) {
      return;
    }
    /*let user_data = this.getUser();
    if (!user_data['has_password']) {
      return;
    }*/

    localStorage.removeItem('user_data');
    //this.storage.set('uid', null);
    this.storage.remove('uid');
    localStorage.removeItem('token');

    this.events.publish('login:set');
  }

  setUser(user_data) {
    user_data['accessed_at'] = this.formatDate(new Date(), 'YYYY/MM/DD hh:mm:ss');
    user_data['local_updated_at'] = this.formatDate(new Date(), 'YYYY/MM/DD hh:mm:ss');
    localStorage.setItem('user_data', JSON.stringify(user_data));
  }

  getUser() {
    let user_data = [];
    if (localStorage.getItem('user_data')) {
      user_data = JSON.parse(localStorage.getItem('user_data'));
    }
    return user_data;
  }

  getServiceID() {
    return SERVICE_ID;
  }

  getService() {
    let service_data = [];
    if (localStorage.getItem('service_data')) {
      service_data = JSON.parse(localStorage.getItem('service_data'));
    }
    service_data['score_name'] = 'スコア';
    if (service_data['score']) {
      if (service_data['score']['name']) {
        service_data['score_name'] = service_data['score']['name'];
      }
      service_data['score_is_publiced'] = service_data['score']['is_publiced'];
    }
    return service_data;
  }

  getDrawer() {
    let drawer_list = [];
    if (localStorage.getItem('drawer_list') && localStorage.getItem('drawer_list') != '') {
      drawer_list = JSON.parse(localStorage.getItem('drawer_list'));

      if (this.isPc()) {
        drawer_list = drawer_list.filter(function(item) {
          return (item['page_target'] != 'ShareIndexPage' 
            && item['page_target'] != 'StampIndexPage'
            && item['page_target'] != 'MemberIndexPage'
            && item['page_target'] != 'InfoIndexPage'
            && item['page_target'] != 'ReaderIndexPage'
            && item['page_target'] != 'InfoProfilePage'
            );
        });
        drawer_list.forEach(function(item) {
          if (item['page_target'] == 'PushIndexPage' 
            || item['page_target'] == 'CouponIndexPage'
            || item['page_target'] == 'EventIndexPage'
            || item['page_target'] == 'MenuIndexPage') {
              item['is_scroll'] = true;
          }
        });
      }
    }
    return drawer_list;
  }

  getCardData() {
    let service_data = this.getService();
    return service_data['app_membership_card'];

    /*let card_data = [];
    if (localStorage.getItem('card_data')) {
      card_data = JSON.parse(localStorage.getItem('card_data'));
    }
    return card_data;*/
  }

  setBrandList(brand_list) {
    brand_list.forEach(function(item) {
      if (item['image_url']) {
        let img = new Image();
        img.src = item['image_url'];
        img.onload = function() {
          let aspect_ratio = img.width / img.height;
          item['aspect_ratio'] = aspect_ratio;
        }
      }
    });
    setTimeout(() => {
        localStorage.setItem('brand_list', JSON.stringify(brand_list));
    }, 3000)
  }

  getBrandList() {
    let brand_list = [];
    if (localStorage.getItem('brand_list')) {
      brand_list = JSON.parse(localStorage.getItem('brand_list'));
    }
    return brand_list;
  }

  getProfileList() {
    let profile_list = [];
    if (localStorage.getItem('profile_list')) {
      profile_list = JSON.parse(localStorage.getItem('profile_list'));
    }
    return profile_list;
  }

  getCouponCategoryList() {
    let coupon_category_list = [];
    if (localStorage.getItem('coupon_category_list')) {
      coupon_category_list = JSON.parse(localStorage.getItem('coupon_category_list'));
    }
    return coupon_category_list;
  }

  getRssList() {
    let rss_list = [];
    if (localStorage.getItem('rss_list')) {
      rss_list = JSON.parse(localStorage.getItem('rss_list'));
    }
    return rss_list;
  }

  getRssData(rss_id) {
    let rss_data = [];
    let rss_list = this.getRssList();

    let find_result = rss_list.find((value) => {
      return (value['id'] == rss_id);
    });
    if (!find_result) {
      return rss_data;
    }
    rss_data = find_result;

    return rss_data;
  }

  setTag(tags) {
    let shop_tag_list = [];

    tags.forEach(function(item) {
      if (item['category'] == 'shop') {
        shop_tag_list.push(item);
      }
    });

    if (shop_tag_list.length) {
      localStorage.setItem('shop_tag_list', JSON.stringify(shop_tag_list));
    } else {
      localStorage.removeItem('shop_tag_list');
    }
  }

  setTopTab(shop_list) {
    let save_shop_list = shop_list.filter(function(item) {
      return (item['page_target']);
    });

    save_shop_list.forEach(function(item) {
      if (item['shop_tab_name']) {
        if (item['shop_tab_name'].includes('\\n')) {
          let shop_tab_names = item['shop_tab_name'].split('\\n');
          item['tab_name_1'] = shop_tab_names[0];
          item['tab_name_2'] = shop_tab_names[1];
        } else {
          item['name'] = item['shop_tab_name'];
        }
      }
    });

    localStorage.setItem('save_shop_list', JSON.stringify(save_shop_list));
  }

  setShopFavorite(shop_id, is_favorite) {
    let save_shop_list = [];
    if (!localStorage.getItem('save_shop_list')) {
      return;
    }
    let service_data = this.getService();
    if (service_data['option']['is_top_tab'] == '2') {
      return;
    }
    save_shop_list = JSON.parse(localStorage.getItem('save_shop_list'));

    save_shop_list.forEach(function(item) {
      if(item['id'] == shop_id) item['is_favorite'] = is_favorite;
    });
    localStorage.setItem('save_shop_list', JSON.stringify(save_shop_list));
  }

  getTopTab() {
    let save_shop_list = [];
    if (localStorage.getItem('save_shop_list')) {
      save_shop_list = JSON.parse(localStorage.getItem('save_shop_list'));
    }
    let service_data = this.getService();
    let top_tab_list = save_shop_list;
    if (service_data['option']['is_top_tab'] != '2') {
      top_tab_list = save_shop_list.filter(function(item) {
        return (item['is_favorite']);
      });
    }

    if (top_tab_list.length > 0) {
      let words_data = this.getWordsData();
      let toppage_tab = 'すべて';
      if (words_data['top_tab']) {
        toppage_tab = words_data['top_tab'];
      }
      let top_tab_icon = this.getImagesValue('top_tab_icon');
      let top_tab_background_color = this.getImagesValue('top_tab_background_color');

      top_tab_list.unshift({name:toppage_tab, page_target:'HomePage', icon:top_tab_icon, background_color:top_tab_background_color});
    }

    return top_tab_list;
  }

  checkTabStart() {
    let service_data = this.getService();
    if (!service_data['option']['is_top_tab'] || !service_data['option']['is_tab_start']) {
      this.deleteStorageData('tab_start');
      return false;
    }

    let tab_start = this.getStorageData('tab_start');
    if (!tab_start['page_target']) {
      return false;
    }

    let save_shop_list = this.getStorageList('save_shop_list');
    let find_tab = save_shop_list.find((value) => {
      return (value['page_target'] == tab_start['page_target'] && value['id'] == tab_start['top_tab_shop_id']);
    });
    if (!find_tab) {
      this.deleteStorageData('tab_start');
      return false;
    }

    if (service_data['option']['is_top_tab'] == '1') {
      if (!find_tab['is_favorite']) {
        this.deleteStorageData('tab_start');
        return false;
      }
    }

    return true;
  }

  getReactionList() {
    let reaction_list = [];
    if (localStorage.getItem('reaction_list')) {
      reaction_list = JSON.parse(localStorage.getItem('reaction_list'));
    }
    return reaction_list;
  }

  setOptions(key, value) {
    let options = this.getOptions();
    options[key] = value;
    localStorage.setItem('options', JSON.stringify(options));
  }

  getOptions() {
    let options = {};
    if (localStorage.getItem('options')) {
      options = JSON.parse(localStorage.getItem('options'));
    }
    return options;
  }

  getOptionsValue(key) {
    let options = {};
    if (localStorage.getItem('options')) {
      options = JSON.parse(localStorage.getItem('options'));
    }
    return options[key];
  }

  getStorageData(key) {
    let data = {};
    if (localStorage.getItem(key)) {
      data = JSON.parse(localStorage.getItem(key));
    }
    return data;
  }

  deleteStorageData(key) {
    localStorage.removeItem(key);
  }

  getStorageList(key) {
    let list = [];
    if (localStorage.getItem(key)) {
      list = JSON.parse(localStorage.getItem(key));
    }
    return list;
  }

  getExternalData() {
    let external_data = [];
    external_data['is_access_token'] = false;

    if (localStorage.getItem('external_data')) {
      external_data = JSON.parse(localStorage.getItem('external_data'));
      external_data['ttl'] = external_data['ttl'] ? external_data['ttl'] : 43200;

      if (external_data['access_token'] && external_data['auth_time']) {
        let diff_second = this.diffSecond(external_data['auth_time']);
        if (diff_second < external_data['ttl']) {
          external_data['is_access_token'] = true;
        }
      }
    }
    return external_data;
  }

  setExternalData(data) {
    data['auth_time'] = this.formatDate(new Date(), 'YYYY/MM/DD hh:mm:ss');
    localStorage.setItem('external_data', JSON.stringify(data));
  }

  isApp() {
    let is_app = localStorage.getItem('is_app')=='1'? true: false;
    return is_app;
  }

  isIos() {
    let is_ios = false;
    if (this.platform.is('ios')) {
      is_ios = true;
    }
    return is_ios;
  }

  isAndroid() {
    let is_android = false;
    if (this.platform.is('android')) {
      is_android = true;
    }
    return is_android;
  }

  isPc() {
    let is_pc = false;
    if (!this.platform.is('mobile') && !this.platform.is('phablet') && !this.platform.is('tablet')) {
      is_pc = true;
    }
    return is_pc;
  }

  isTablet() {
    let is_tablet = false;
    if (this.platform.is('phablet') || this.platform.is('tablet')) {
      is_tablet = true;
    }
    return is_tablet;
  }

  isPcWidth() {
    let is_pc_width = false;
    if (window.innerWidth > 768) {
      is_pc_width = true;
    }
    return is_pc_width;
  }

  getOsVersion() {
    let os_version = '';
    if (this.platform.is('android')) {
      os_version = this.platform['_versions']['android']['str'];
    } else if (this.platform.is('ios')) {
      os_version = this.platform['_versions']['ios']['str'];
    }
    return os_version;
  }

  isPwaAccount() {
    let is_pwa_account = false;
    let service_data = this.getService();
    if (service_data['is_pwa_account']) {
      is_pwa_account = true;
    }

    return is_pwa_account;
  }

  checkTop() {
    let top_flg:boolean = false;
    let user_data = this.getUser();
    if (this.isApp()) {
      if (user_data['is_set'] != 1){
        top_flg = true;
      }
    } else {
      if (!user_data['has_password']){
        top_flg = true;
      }
    }

    return top_flg;
  }

  alertLogin(navCtrl) {
    let alert;

    if (this.isPwaAccount() && !this.isPc()) {
      alert = this.alertCtrl.create({
        message: 'この機能を利用する場合、ログインが必要です。',
        enableBackdropDismiss:false,
        buttons: [
          {
            text: 'はい',
            handler: () => {
              navCtrl.setRoot('LoginPage');
            }
          },
          {
            text: 'いいえ',
            role: 'cancel',
          }, 
        ]
      });
    } else {
      alert = this.alertCtrl.create({
        message: 'この機能を利用する場合、アプリが必要です。',
        enableBackdropDismiss:false,
        buttons: [
          {
            text: 'はい',
            handler: () => {
              navCtrl.setRoot('SharePage');
            }
          },
          {
            text: 'いいえ',
            role: 'cancel',
          }, 
        ]
      });
    }
    alert.present();
    return alert;
  }

  popPin(page='') {
    if (!this.isApp()) {
      return;
    }
    if (this.getOptionsValue('not_pop_pin')) {
      return;
    }
    let service_data = this.getService();
    if (page && service_data['option']['inherit_popup'] != null) {
      let position;
      switch(page) {
        case 'coupon':
          position = 0;
          break;
        case 'stamp':
          position = 1;
          break;
        case 'member':
          position = 2;
          break;
        case 'info':
          position = 3;
          break;
      }
      if (position != null) {
        let chk_pop = this.isBitOn(service_data['option']['inherit_popup'], position);
        if (!chk_pop) {
          return;
        }
      }
    }
    
    let pop_use = this.popoverCtrl.create(
      'PopPinPage',
      {},
      {cssClass:'custom_popover',enableBackdropDismiss:false}
    );
    pop_use.present();
  }

  profileRequired(navCtrl, page) {
    let service_data = this.getService();
    if (service_data['option']['profile_required'] == null) {
      return;
    }

    let position;
    let message;
    switch(page) {
      case 'coupon':
        position = 0;
        message = 'クーポンをご利用する場合、プロフィールを全て登録してください。';
        break;
      case 'stamp':
        position = 1;
        message = 'スタンプをご利用する場合、プロフィールを全て登録してください。';
        break;
    }
    if (position == null) {
      return;
    }
    let chk_pop = this.isBitOn(service_data['option']['profile_required'], position);
    if (!chk_pop) {
      return;
    }

    let user_data = this.getUser();
    let chk_profile = false;
    if (!user_data['nickname']) {
      chk_profile = true;
    }
    if (!user_data['birthday']) {
      chk_profile = true;
    }
    if (!user_data['gender']) {
      chk_profile = true;
    }
    if (service_data['option']['is_user_zip_code']) {
      if (!user_data['zip_code']) {
        chk_profile = true;
      }
    }
    if (!chk_profile) {
      return;
    }

    let alert = this.alertCtrl.create({
      message: message,
      enableBackdropDismiss:false,
      buttons: [
        {
          text: 'はい',
          handler: () => {
            navCtrl.setRoot('InfoProfilePage');
          }
        },
        {
          text: 'いいえ',
          role: 'cancel',
        },
      ]
    });
    alert.present();
    return true;
  }

  isBitOn(value:number, position:number) {
    return (value & (1 << position)) !== 0;
  }

  reload() {
    if (this.isApp()) {
      if (this.platform.is('android')) {
        window.ionic.postMessage('Reload');
      } else if (this.platform.is('ios')) {
        window.webkit.messageHandlers.ionic.postMessage('Reload');
      }
    } else {
      window.location.reload(true);
    }
  }

  restart() {
    if (this.isApp()) {
      let app_version = localStorage.getItem('app_version');
      window.location.href = '/?app_version=' + app_version;
    } else {
      window.location.href = '/';
    }
  }

  goPage(data, navCtrl, gaProv) {    
    if (data['target'] == data['current_page']) {
      if (data['target'].indexOf('FreeIndexPage-') !== 0) {
        return;
      }
    }

    if (data['target']=='Web') {
      if (data['url']) {
        gaProv.trackClick(data['category'], '外部リンク', data['url']);
        this.checkLink(data['url'], navCtrl);
      }
    } else if (data['target'] == 'ShareIndexPage') {
      gaProv.trackClick(data['category'], data['target']);
      this.goShare();
    } else if (data['target'] == 'HomePage') {
      gaProv.trackClick(data['category'], data['target']);
      navCtrl.setRoot('home');
    } else if (data['target'].indexOf('FreeIndexPage-') === 0) {
      let targets = data['target'].split('-');
      gaProv.trackClick(data['category'], data['target']);
      let shop_id = 0;
      if (data['top_tab_shop_id']) {
        shop_id = data['top_tab_shop_id'];
      }
      navCtrl.setRoot(targets[0], {free_id:targets[1],shop_id:shop_id});
    } else if (data['target'] == 'MenuIndexPage') {
      gaProv.trackClick(data['category'], data['target']);
      navCtrl.setRoot('MenuIndexPage', {target_id:0});
    } else if (data['target'].indexOf('CategoryMenuIndexPage-') === 0) {
      let targets = data['target'].split('-');
      gaProv.trackClick(data['category'], data['target']);
      navCtrl.setRoot('MenuIndexPage', {target_id:targets[1]});
    } else if (data['target'].indexOf('IndexPage') === -1) {
      navCtrl.push(data['target']);
    } else if (data['target']) {
      if (this.isGoLogin(data['target'])) {
        gaProv.trackClick(data['category'], data['target']);
        navCtrl.setRoot(data['target']);
      } else {
        this.alertLogin(navCtrl);
      }
    }
  }

  goPagePc(item, navCtrl, page) {
    if (item['page_url']) {
      this.checkLink(item['page_url'], navCtrl);
    } else if (item['page_target'] == 'HomePage') {
      this.scrollTo('pageTop', navCtrl, page);
    } else if (item['page_target'].indexOf('FreeIndexPage-') === 0) {
      let targets = item['page_target'].split('-');
      navCtrl.setRoot(targets[0], {free_id:targets[1]});
    } else if (item['page_target'].indexOf('CategoryMenuIndexPage-') === 0) {
      this.scrollTo(item['page_target'], navCtrl, page);
    } else if (item['is_scroll']) {
      this.scrollTo(item['page_target'], navCtrl, page);
    } else if (item['page_target']) {
      navCtrl.setRoot(item['page_target']);
    }
  }

  scrollTo(id, navCtrl, page) {
    if (page == 'HomePage') {
      let element = document.getElementById(id);
      if (element) {
        element.scrollIntoView();
      } 
    } else {
      navCtrl.setRoot('home',{scroll_id:id});
    }
  }

  checkLink(url, navCtrl) {
    let service_data = this.getService();
    let pwa_url = service_data['pwa_url'];

    if (url.indexOf(pwa_url) === 0) {
      let root_list = [
        {url:'shop-index',page:'ShopIndexPage'},
        {url:'event-index',page:'EventIndexPage'},
        {url:'coupon-index',page:'CouponIndexPage'},
        {url:'menu-index',page:'MenuIndexPage',id:'target_id'},
        {url:'photo-index',page:'PhotoIndexPage'},
        {url:'push-index',page:'PushIndexPage'},
        {url:'movie-index',page:'MovieIndexPage'},
        {url:'stamp-index',page:'StampIndexPage'},
        {url:'member-index',page:'MemberIndexPage'},
        {url:'free-index',page:'FreeIndexPage',id:'free_id'},
        {url:'point-index',page:'PointIndexPage'},
        {url:'mypage-wfk',page:'MypageWfkPage'},
        {url:'event-site',page:'EventSitePage',id:'shop_id',id2:'site_flg'},
        {url:'stamp-mycard',page:'StampMycardPage'},
      ];
      let push_list = [
        {url:'shop-detail',page:'ShopDetailPage',id:'shop_id'},
        {url:'event-detail',page:'EventDetailPage',id:'event_id'},
        {url:'menu-detail',page:'MenuDetailPage',id:'target_id',id2:'menu_id'},
        {url:'photo-detail',page:'PhotoDetailPage',id:'photo_id'},
        {url:'stamp-multi',page:'StampMultiPage',id:'multi_stamp_id'},
      ];

      let root_result = root_list.find((value) => {
        return (url.indexOf('/#/' + value['url']) > 0);
      });
      if (root_result) {
        if (root_result['id2']) {
          let pattern = new RegExp('/#/' + root_result['url'] + '/(\\d+)/(\\d+)');
          let match = url.match(pattern);
          navCtrl.setRoot(root_result['page'],{[root_result['id']]:match[1],[root_result['id2']]:match[2]});
        } else if (root_result['id']) {
          let pattern = new RegExp('/#/' + root_result['url'] + '/(\\d+)');
          let match = url.match(pattern);
          if (root_result['url'] == 'free-index') {
            navCtrl.setRoot(root_result['page'],{[root_result['id']]:match[1],'shop_id':0});
          } else {
            navCtrl.setRoot(root_result['page'],{[root_result['id']]:match[1]});
          }
        } else {
          navCtrl.setRoot(root_result['page']);
        }
        return;
      }

      let push_result = push_list.find((value) => {
        return (url.indexOf('/#/' + value['url']) > 0);
      });
      if (push_result) {
        if (push_result['id2']) {
          let pattern = new RegExp('/#/' + push_result['url'] + '/(\\d+)/(\\d+)');
          let match = url.match(pattern);
          navCtrl.push(push_result['page'],{[push_result['id']]:match[1],[push_result['id2']]:match[2]});
        } else {
          let pattern = new RegExp('/#/' + push_result['url'] + '/(\\d+)');
          let match = url.match(pattern);
          navCtrl.push(push_result['page'],{[push_result['id']]:match[1]});
        }
      }
    } else {
      // 外部ブラウザ表示
      if (!this.isApp()) {
        if (url.indexOf('browser://?url=') !== -1) {
          // シェアページ
          navCtrl.setRoot('SharePage');
          return;
        }
      }

      this.setLink(url);
    }
  }

  setLink(url) {
    if (!url || url == '') {
      return;
    }

    // Webviewチェック
    let find_webview;
    if (this.isApp() && (this.platform.is('android') || this.platform.is('ios'))) {
      let webview_data = JSON.parse(localStorage.getItem('webview_data'));
      if (webview_data) {
        find_webview = webview_data.find((value) => {
          let str_url = value['url'];

          // エスケープとワイルドカード
          str_url = str_url.replace(/\./g, '\\.');
          str_url = str_url.replace(/\?/g, '\\?');
          str_url = str_url.replace(/\*/g, '.*');

          let pattern = new RegExp(str_url);
          let match = pattern.test(url);
          return (match);
          //return (value['url'] == url);
        });
      }
    }

    url = this.replaceUrl(url);
    if (this.isApp() && (this.platform.is('android') || this.platform.is('ios'))) {
      if (this.platform.is('android')) {
        try {
          if (find_webview) {
            window.ionic.postInWebBrowser(url, find_webview['_links']['css']['href']);
          } else {
            window.ionic.postWebBrowser(url);
          }
        } catch(e) {
          console.log(e);
        }
      } else {
        url = decodeURI(url);
        try {
          if (find_webview) {
            let message = {
              action: 'InWebBrowser',
              parameters: {
                url: url,
                css: find_webview['_links']['css']['href']
              }
            };
            window.webkit.messageHandlers.ionic.postMessage(message);
          } else {
            let message = {
              action: 'WebBrowser',
              parameters: {
                  url: url
              }
            };
            window.webkit.messageHandlers.ionic.postMessage(message);
          }
        } catch(e) {
          console.log(e);
        }
      }
    } else {
      window.open(url, '_blank');
    }
  }

  setWebview(url) {
    if (this.isApp() && (this.platform.is('android') || this.platform.is('ios'))) {
      let css = '';
      let url_obj = new URL(url);
      let url_domain = url_obj.hostname;
      let webview_data = JSON.parse(localStorage.getItem('webview_data'));
      let find_webview;

      if (webview_data) {
        find_webview = webview_data.find((value) => {
          return (value['url'].indexOf(url_domain) != -1);
        });
      }
      if (find_webview) {
        css = find_webview['_links']['css']['href'];
      }

      if (this.platform.is('android')) {
        try {
          window.ionic.postInWebBrowser(url, css);
        } catch(e) {
          console.log(e);
        }
      } else {
        url = decodeURI(url);
        try {
          let message = {
            action: 'InWebBrowser',
            parameters: {
              url: url,
              css: css
            }
          };
          window.webkit.messageHandlers.ionic.postMessage(message);
        } catch(e) {
          console.log(e);
        }
      }
    } else {
      window.open(url, '_blank');
      //window.location.href = url;
    }
  }

  closeWebview(url) {
    new Image().src = '?closeWebview=1&common';
    try {
      if (this.isAndroid()) {
        window.ionic.postInWebBrowserClose(url);
      } else if (this.isIos()) {
        new Image().src = '?closeWebview=1&ios';
        var message = {
          action: 'InWebBrowserClose',
          parameters: {
              url: url
          }
        };
        window.webkit.messageHandlers.ionic.postMessage(message);
      }
    } catch(e) {
      new Image().src = '?closeWebview=1&error';
      console.log(e);
    }
  }

  getAppUid() {
    try {
      if (this.isAndroid()) {
        window.ionic.postMessage('uid');
      } else if (this.isIos()) {
        window.webkit.messageHandlers.ionic.postMessage('uid');
      }
    } catch(e) {
      console.log(e);
    }
  }

  getAppToken() {
    try {
      if (this.isAndroid()) {
        window.ionic.postMessage('token');
      } else if (this.isIos()) {
        window.webkit.messageHandlers.ionic.postMessage('token');
      }
    } catch(e) {
      console.log(e);
    }
  }

  getAppUser() {
    try {
      if (this.isAndroid()) {
        window.ionic.postMessage('user_authenticate');
      } else if (this.isIos()) {
        window.webkit.messageHandlers.ionic.postMessage('user_authenticate');
      }
    } catch(e) {
      console.log(e);
    }
  }

  getAppLocation() {
    try {
      if (this.isAndroid()) {
        window.ionic.postMessage('Location');
      } else if (this.isIos()) {
        window.webkit.messageHandlers.ionic.postMessage('Location');
      }
    } catch(e) {
      console.log(e);
    }
  }

  getAppBarcode() {
    try {
      if (this.isAndroid()) {
        window.ionic.postMessage('QRCodeReader');
      } else if (this.isIos()) {
        window.webkit.messageHandlers.ionic.postMessage('QRCodeReader');
      }
    } catch(e) {
      console.log(e);
    }
  }

  getLinkRay() {
    try {
      if (this.isAndroid()) {
        window.ionic.postMessage('LinkRay');
      } else if (this.isIos()) {
        window.webkit.messageHandlers.ionic.postMessage('LinkRay');
      }
    } catch(e) {
      console.log(e);
    }
  }

  getBeacon() {
    try {
      if (this.isAndroid()) {
        window.ionic.postMessage('AIBeaconStamp');
      } else if (this.isIos()) {
        window.webkit.messageHandlers.ionic.postMessage('AIBeaconStamp');
      }
    } catch(e) {
      console.log(e);
    }
  }

  setBright() {
    try {
      if (this.isAndroid()) {
        window.ionic.postMessage('BrightnessOn');
      } else if (this.isIos()) {
        window.webkit.messageHandlers.ionic.postMessage('BrightnessOn');
      }
    } catch(e) {
      console.log(e);
    }
  }

  setDark() {
    try {
      if (this.isAndroid()) {
        window.ionic.postMessage('BrightnessOff');
      } else if (this.isIos()) {
        window.webkit.messageHandlers.ionic.postMessage('BrightnessOff');
      }
    } catch(e) {
      console.log(e);
    }
  }

  goPush() {
    try {
      if (this.isAndroid()) {
        window.ionic.postMessage('PushSetting');
      } else if (this.isIos()) {
        window.webkit.messageHandlers.ionic.postMessage('PushSetting');
      }
    } catch(e) {
      console.log(e);
    }
  }

  setBadge(number) {
    if (!this.isApp()) {
      return;
    }
    try {
      if (this.isIos()) {
        var message = {
          action: 'Badge',
          parameters: {
            number: number
          }
        };
        window.webkit.messageHandlers.ionic.postMessage(message);
      }
    } catch(e) {
      console.log(e);
    }
  }

  getPushStatus() {
    try {
      if (this.isIos()) {
        window.webkit.messageHandlers.ionic.postMessage('PushStatus');
      }
    } catch(e) {
      console.log(e);
    }
  }

  getPoint() {
    try {
      if (this.isAndroid()) {
        window.ionic.postMessage('Point');
      } else if (this.isIos()) {
        window.webkit.messageHandlers.ionic.postMessage('Point');
      }
    } catch(e) {
      console.log(e);
    }
  }

  getPointHistory() {
    try {
      if (this.isAndroid()) {
        window.ionic.postMessage('PointHistory');
      } else if (this.isIos()) {
        window.webkit.messageHandlers.ionic.postMessage('PointHistory');
      }
    } catch(e) {
      console.log(e);
    }
  }

  getMypage() {
    if (!this.isApp()) {
      return;
    }

    try {
      if (this.isAndroid()) {
        window.ionic.postMessage('Mypage');
      } else if (this.isIos()) {
        window.webkit.messageHandlers.ionic.postMessage('Mypage');
      }
    } catch(e) {
      console.log(e);
    }
  }

  zoomImage(src) {
    try {
      if (this.isAndroid()) {
        window.ionic.postImage(src);
      } else if (this.isIos()) {
        var message = {
          action: 'Image',
          parameters: {
              src: src
          }
        };
        window.webkit.messageHandlers.ionic.postMessage(message);
      }
    } catch(e) {
      console.log(e);
    }
  }

  copyText(text) {
    try {
      if (this.isApp()) {
        if (this.isAndroid()) {
          window.ionic.postCopy(text);
        } else if (this.isIos()) {
          var message = {
            action: 'Copy',
            parameters: {
                text: text
            }
          };
          window.webkit.messageHandlers.ionic.postMessage(message);
        }
      } else {
        navigator.clipboard.writeText(text).then(() => {
          console.log('copy ok');
        }).catch(err => {
          console.error("copy err:", err);
        });
      }
    } catch(e) {
      console.log(e);
    }
  }

  takeOver() {
    try {
      if (this.isAndroid()) {
        window.ionic.postMessage('Takeover');
      } else if (this.isIos()) {
        window.webkit.messageHandlers.ionic.postMessage('Takeover');
      }
    } catch(e) {
      console.log(e);
    }
  }

  goShare() {
    let service_data = this.getService();
    let text = '「' + service_data['name'] + '」アプリをインストールしてください。';
    let url = service_data['pwa_url'] + '/#/share';

    if (this.isApp()) {
      try {
        if (this.isAndroid()) {
          window.ionic.postShare(text, url);
        } else if (this.isIos()) {
          var message = {
            action: 'Share',
            parameters: {
                text: text,
                url: url
            }
          };
          window.webkit.messageHandlers.ionic.postMessage(message);
        }
      } catch(e) {
        console.log(e);
      }
    } else {
      if (navigator.share) {
        navigator.share({
          title: 'アプリの紹介',
          text: text,
          url: url
        }).then(() => {
          console.log('ShareWeb ok');
        })
        .catch(err => {
          console.log(`ShareWeb err`);
        });
      } else {
        this.dispAlert('シェアボタンに対応していません。');
      }
    }
  }

  setMemberBarcode() {
    if (!this.isApp()) {
      return;
    }

    let barcode_text = this.getMemberBarcodeText();
    if (!barcode_text) {
      return;
    }

    try {
      if (this.isAndroid()) {
        window.ionic.postMemberBarcode(String(barcode_text));
      } else if (this.isIos()) {
        var message = {
          action: 'MemberBarcode',
          parameters: {
            barcode: String(barcode_text)
          }
        };
        window.webkit.messageHandlers.ionic.postMessage(message);
      }
    } catch(e) {
      console.log(e);
    }
  }

  getMemberBarcodeText() {
    let user_data = this.getUser();
    if (!user_data['id']) {
      return;
    }

    let service_data = this.getService();
    if (!service_data['app_membership_card']) {
      return;
    }
    let card_data = service_data['app_membership_card'];
    if (card_data['is_barcode'] != 1 || !card_data['barcode_format']) {
      return;
    }
    if (!card_data['is_user_id_barcode']) {
      if (!user_data['member_code']) {
        return;
      }
      if (!this.checkBarcodeFormat(user_data['member_code'])) {
        return;
      }
    }

    let barcode_text = '';
    if (card_data['is_user_id_barcode']) {
      if (service_data['option']['member_barcode_pattern']) {
        barcode_text = this.generateBarcodeString(user_data['id'], service_data['option']['member_barcode_pattern'], card_data['barcode_format']);
      } else {
        barcode_text = user_data['id'];
      }
    } else {
      barcode_text = user_data['member_code'];
    }

    return barcode_text;
  }

  generateJan13(user_id, pattern) {
    let filled = this.fillTemplate(pattern, user_id);
    let numeric = filled.replace(/\D/g, ''); // 数字だけ抽出

    if (numeric.length !== 12) {
      throw new Error(`Formatted code must be 12 digits, got: ${numeric}`);
    }

    let check_digit = this.calculateCheckDigit(numeric);
    return numeric + check_digit;
  }

  generateBarcodeString(user_id, pattern, format) {
    let filled = this.fillTemplate(pattern, user_id);
    if (format != 'EAN13') {
      return filled;
    }

    let numeric = filled.replace(/\D/g, ''); // 数字だけ抽出

    if (numeric.length !== 12) {
      throw new Error(`Formatted code must be 12 digits, got: ${numeric}`);
    }

    let check_digit = this.calculateCheckDigit(numeric);
    return numeric + check_digit;
  }

  fillTemplate(pattern, number) {
    let digits = number.toString().split('').reverse(); // 右から使う
    let result = '';
    let digitIndex = 0;

    for (let i = pattern.length - 1; i >= 0; i--) {
      if (pattern[i] === '#') {
        let str_idx = digits[digitIndex++];
        result = (str_idx ? str_idx : '0') + result; // 足りなければゼロ
      } else {
        result = pattern[i] + result;
      }
    }

    if (digitIndex < digits.length) {
      throw new Error('Number is too long for the given pattern');
    }

    return result;
  }

  calculateCheckDigit(jan12) {
    let digits = jan12.split('').map(Number);
    let sum = 0;
    for (let i = 0; i < digits.length; i++) {
      sum += digits[i] * (i % 2 === 0 ? 1 : 3);
    }
    let mod = sum % 10;
    return mod === 0 ? 0 : 10 - mod;
  }

  goGoogleplay() {
    let service_data = this.getService();
    let url = 'https://play.google.com/store/apps/details?id=' + service_data['android_application_id'];
    window.open(url, '_blank');
  }

  goAppstore() {
    let service_data = this.getService();
    let url = 'https://itunes.apple.com/jp/app/id' + service_data['apple_id'] + '?mt=8';
    window.open(url, '_blank');
  }

  replaceUrl(text, type=0) {
    //【type】0:WebView/ 1:QRコード/ 2:iframe
    let user_id = '';
    let member_code = '';
    let nickname = '';
    let gender = '';
    let birthday = '';
    let zip_code = '';
    let user_auth_key = '';
    let user_data = this.getUser();
    if (user_data) {
      if (user_data['id']) {
        user_id = user_data['id'];
      }
      if (user_data['member_code']) {
        member_code = user_data['member_code'];
      }
      if (user_data['nickname']) {
        nickname = user_data['nickname'];
      }
      if (user_data['gender']) {
        if (user_data['gender'] == 1) {
          gender = 'man';
        } else if (user_data['gender'] == 2) {
          gender = 'woman';
        }
      }
      if (user_data['birthday']) {
        birthday = user_data['birthday'];
      }
      if (user_data['zip_code']) {
        zip_code = user_data['zip_code'];
      }
      if (user_data['user_auth_key']) {
        user_auth_key = user_data['user_auth_key'];
      }
      if (type == 0) {
        if (!this.isApp() || !this.isIos()) {
          // iOSアプリはアプリ側でエンコードしているので除外
          member_code = encodeURIComponent(member_code);
          nickname = encodeURIComponent(nickname);
          user_auth_key = encodeURIComponent(user_auth_key);
        }
      } else if (type == 2) {
        member_code = encodeURIComponent(member_code);
        nickname = encodeURIComponent(nickname);
        user_auth_key = encodeURIComponent(user_auth_key);
      }
    }

    if (text.indexOf('@@hash@@') !== -1) {
      let hash_arr = [];
      if (text.indexOf('@@user_id@@') !== -1) {
        hash_arr.push(user_id);
      }
      if (text.indexOf('@@member_code@@') !== -1) {
        hash_arr.push(member_code);
      }
      hash_arr.push(SERVICE_ID);
      let hash_original = hash_arr.join(':');
      let hash_str = CryptoJS.SHA256(hash_original).toString(CryptoJS.enc.Hex);
      text = text.replace(/@@hash@@/g, hash_str);
    }

    if (text.indexOf('@@user_id@@') !== -1) {
      text = text.replace(/@@user_id@@/g, user_id);
    }

    if (text.indexOf('@@member_code@@') !== -1) {
      text = text.replace(/@@member_code@@/g, member_code);
    }
    if (text.indexOf('@@nickname@@') !== -1) {
      text = text.replace(/@@nickname@@/g, nickname);
    }
    if (text.indexOf('@@gender@@') !== -1) {
      text = text.replace(/@@gender@@/g, gender);
    }
    if (text.indexOf('@@birthday@@') !== -1) {
      text = text.replace(/@@birthday@@/g, birthday);
    }
    if (text.indexOf('@@post_code@@') !== -1) {
      text = text.replace(/@@post_code@@/g, zip_code);
    }
    if (text.indexOf('@@user_auth_key@@') !== -1) {
      text = text.replace(/@@user_auth_key@@/g, user_auth_key);
    }

    return text;
  }

  setUserEnv(data) {
    let os_type    = this.getOsType();
    let os_version = '';
    let app_type   = this.isApp()? 'APP': 'WEB';
    if (this.platform.is('android')) {
      //os_type = 'Android';
      os_version = this.platform['_versions']['android']['str'];
    } else if (this.platform.is('ios')) {
      //os_type = 'iOS';
      os_version = this.platform['_versions']['ios']['str'];
    } else {
      //os_type = 'PC';
      os_version = '1.0';
    }

    data['os_type']    = os_type;
    data['os_version'] = os_version;
    data['app_type']   = app_type;
    data['user_agent'] = this.platform['_ua'];
    if (app_type == 'APP') {
      data['app_version'] = localStorage.getItem('app_version');
    }

    return data;
  }

  getOsType() {
    let os_type = '';
    if (this.platform.is('android')) {
      os_type = 'Android';
    } else if (this.platform.is('ios')) {
      os_type = 'iOS';
    } else {
      os_type = 'PC';
    }
    return os_type;
  }

  getAppVersion() {
    let app_version = null;

    if (!this.isApp()) {
      return app_version;
    }

    let local_app_version = localStorage.getItem('app_version');
    if (!local_app_version) {
      return app_version;
    }

    let match = local_app_version.match(/^[0-9]+\.[0-9]+/);
    console.log('match', match);
    if (!match) {
      return app_version;
    }
    app_version = match[0];

    return app_version;
  }

  goNavi(shop_data) {
    let url;
    if (this.platform.is('ios')) {
      url = 'https://maps.apple.com/?saddr=&daddr=' + shop_data['lat'] +',' + shop_data['lng'] + '&z=16';
      if (this.isApp()) {
        url = 'browser://?url=' + url;
      }
    } else {
      url = 'https://maps.google.com/maps?saddr=&daddr=' + shop_data['lat'] +',' + shop_data['lng'] + '&z=16';
    }
    this.setLink(url);
  }

  countTime(limit_time) {
    let tmp = limit_time.replace(/-/g, '/');
    let date_now = new Date();
    let date_end = new Date(tmp);

    let sDiff = (date_end.getTime() - date_now.getTime()) / 1000;

    if (sDiff < 0) {
      sDiff = 0;
    }

    let day  = String(Math.floor(sDiff / (24 * 60 * 60)));
    let hour = String(Math.floor(sDiff % (24 * 60 * 60) / (60 * 60)));
    let min  = String(Math.floor(sDiff % (24 * 60 * 60) % (60 * 60) / 60));
    let sec  = String(Math.floor(sDiff % (24 * 60 * 60) % (60 * 60) % 60));

    min = ('00' + min).slice(-2);
    sec = ('00' + sec).slice(-2);
    return {'day':day,'hour':hour,'min':min,'sec':sec};
  }

  sendLog(params) {
    let user_data = this.getUser();
    let log_text = '';

    log_text += '?user_id=' + user_data['id'];
    log_text += '&os_type=' + this.getOsType();
    for (let key in params) {
      log_text += '&' + key + '=' + params[key];
    }
    
    new Image().src = log_text;
  }

  countDay(chk_time, is_pre = false) {
    if (!chk_time) {
      return;
    }
    let date_now = new Date();
    let split = chk_time.split(' ');

    let msDiff;
    if (is_pre) {
      let tmp = split[0].replace(/-/g, '/') + ' 00:00:00';
      let date_chk = new Date(tmp);
      msDiff = (date_now.getTime() - date_chk.getTime()) / 1000;
    } else {
      let tmp = split[0].replace(/-/g, '/') + ' 23:59:59';
      let date_chk = new Date(tmp);
      msDiff = (date_chk.getTime() - date_now.getTime()) / 1000;
    }

    if (msDiff < 0) {
      msDiff = 0;
    }
    let day  = String(Math.floor(msDiff / (24 * 60 * 60)));

    return day;
  }

  getRemainDay(expiration_at, base_time=null) {
    if (!expiration_at) {
      return null;
    }
    let expire_date = new Date(expiration_at.replace(/-/g, '/').split(' ')[0]);
    let now_date = new Date();
    if (base_time) {
      now_date = new Date(base_time.replace(/-/g, '/'));
    }
    expire_date = new Date(expire_date.getFullYear(), expire_date.getMonth(), expire_date.getDate());
    now_date = new Date(now_date.getFullYear(), now_date.getMonth(), now_date.getDate());
    return (expire_date.getTime() - now_date.getTime()) / (24 * 60 * 60 * 1000);
  }

  getClock() {
    let now = new Date();

    let year  = now.getFullYear();
    let month = ('0' + (now.getMonth() + 1)).slice(-2);
    let day   = ('0' + now.getDate()).slice(-2);
    let hour  = ('0' + now.getHours()).slice(-2);
    let min   = ('0' + now.getMinutes()).slice(-2);
    let sec   = ('0' + now.getSeconds()).slice(-2);

    return {'year':year,'month':month,'day':day,'hour':hour,'min':min,'sec':sec};
  }

  formatDate(date, format) {
    format = format.replace(/YYYY/, date.getFullYear());
    format = format.replace(/MM/, ('0' + (date.getMonth() + 1)).slice(-2));
    format = format.replace(/MO/, date.getMonth() + 1);
    format = format.replace(/DD/, ('0' + date.getDate()).slice(-2));
    format = format.replace(/DA/, date.getDate());
    format = format.replace(/hh/, ('0' + date.getHours()).slice(-2));
    format = format.replace(/mm/, ('0' + date.getMinutes()).slice(-2));
    format = format.replace(/ss/, ('0' + date.getSeconds()).slice(-2));

    return format;
  }

  diffSecond(chk_time, base_time=null) {
    let date_now = new Date();
    if (base_time) {
      date_now = new Date(base_time.replace(/-/g, '/'));
    }
    let date_chk = new Date(chk_time.replace(/-/g, '/'));

    let sDiff = (date_now.getTime() - date_chk.getTime()) / 1000;

    return Math.floor(sDiff);
  }

  checkTime(last_time, str_check_time=null, obj_check_time=null) {
    if (!last_time) {
      return true;
    }

    let last_date  = new Date(last_time.replace(/-/g, '/'));
    let check_date = new Date();
    if (str_check_time) {
      check_date = new Date(str_check_time.replace(/-/g, '/'));
    } else if (obj_check_time) {
      check_date = obj_check_time;
    }

    if (last_date.getTime() < check_date.getTime()) {
      return true;
    }

    return false;
  }

  getTimestamp(str_time) {
    let obj_time  = new Date(str_time.replace(/-/g, '/'));

    return obj_time.getTime();
  }

  setPrefecture(shop_list) {
    let prefecture_list = [];
    for (let i=0; i<shop_list.length; i++) {
      var pre_code = shop_list[i]['prefecture_code'];
      let result = prefecture_list.some(function(value) {
        return value['prefecture_code'] == pre_code;
      });
      if (result) {
        continue;
      }
      
      let item = {
        prefecture_code: shop_list[i]['prefecture_code'],
        prefecture: shop_list[i]['prefecture'],
      };
      prefecture_list.push(item);
    }
    prefecture_list.sort(function(a, b){return(a['prefecture_code'] - b['prefecture_code']);});

    return prefecture_list;
  }

  setBrand(shop_list) {
    let brand_list = [];
    for (let i=0; i<shop_list.length; i++) {
      if (!shop_list[i]['brand']) {
        continue;
      }
      if (!shop_list[i]['id']) {
        continue;
      }
      var brand_id = shop_list[i]['brand']['id'];
      let result = brand_list.some(function(value) {
        return value['brand_id'] == brand_id;
      });
      if (result) {
        continue;
      }
      
      let item = {
        brand_id: shop_list[i]['brand']['id'],
        brand_name: shop_list[i]['brand']['name'],
        view_position: shop_list[i]['brand']['view_position']
      };
      brand_list.push(item);
    }
    brand_list.sort(function(a, b){return(b['view_position'] - a['view_position']);});

    return brand_list;
  }

  getDistance(lat1, lng1, lat2, lng2) {
    lat1 *= Math.PI / 180;
    lng1 *= Math.PI / 180;
    lat2 *= Math.PI / 180;
    lng2 *= Math.PI / 180;
    return 6371 * Math.acos(Math.cos(lat1) * Math.cos(lat2) * Math.cos(lng2 - lng1) + Math.sin(lat1) * Math.sin(lat2));
  }

  dispShop(shop_list, brand_id, prefecture_code, is_favorite=null, shop_tag_ids=null) {
    for (let i=0; i<shop_list.length; i++) {
      if (is_favorite) {
        if (!shop_list[i]['is_favorite']) {
          shop_list[i]['is_hidden'] = true;
          continue;
        }
      }
      if (brand_id != 0) {
        if (!shop_list[i]['brand_id']) {
          shop_list[i]['is_hidden'] = true;
          continue;
        }
        if (shop_list[i]['brand_id'] != brand_id) {
          shop_list[i]['is_hidden'] = true;
          continue;
        }
        /*if (!shop_list[i]['brand']) {
          shop_list[i]['is_hidden'] = true;
          continue;
        }
        if (shop_list[i]['brand']['id'] != brand_id) {
          shop_list[i]['is_hidden'] = true;
          continue;
        }*/
      }
      if (prefecture_code != 0) {
        if (shop_list[i]['prefecture_code'] != prefecture_code) {
          shop_list[i]['is_hidden'] = true;
          continue;
        }
      }
      if (shop_tag_ids && shop_tag_ids.length) {
        if (!shop_list[i]['shop_tags']) {
          shop_list[i]['is_hidden'] = true;
          continue;
        }
        if (shop_list[i]['shop_tags'].length == 0) {
          shop_list[i]['is_hidden'] = true;
          continue;
        }

        let tag_list = shop_list[i]['shop_tags'].map(item => item.id);
        let result = shop_tag_ids.every(value => tag_list.includes(Number(value)));
        if (!result) {
          shop_list[i]['is_hidden'] = true;
          continue;
        }
      }
      shop_list[i]['is_hidden'] = false;
    }
    return shop_list;
  }

  dispEvent(event_list, category_id, month_offset=null) {
    let event_disp = [];
    let offset_start;
    let offset_end;
    if (month_offset != null) {
      let now = new Date();
      offset_start = this.formatDate(new Date(now.getFullYear(), now.getMonth() + month_offset, 1), 'YYYY-MM-DD 00:00:00');
      offset_end   = this.formatDate(new Date(now.getFullYear(), now.getMonth() + month_offset + 1, 0), 'YYYY-MM-DD 23:59:59');
    }

    for (let i=0; i<event_list.length; i++) {
      if (category_id != 0) {
        if (event_list[i]['category_id'] != category_id) {
          continue;
        }
      }
      if (month_offset != null) {
        if (event_list[i]['limit_start_at'] > offset_end) {
          continue;
        }
        if (event_list[i]['limit_end_at'] < offset_start) {
          continue;
        }
      }
      event_disp.push(event_list[i]);
    }

    return event_disp;
  }

  getInitialDate() {
    var day = new Date();
    let initial_date 
      = String(day.getFullYear() - 25) + '-' 
      + ('0' + String(day.getMonth() + 1)).slice(-2) + '-' 
      + ('0' + String(day.getDate())).slice(-2);

    return initial_date;
  }

  dispAlert(message) {
    let my_alert = this.alertCtrl.create({
      message: message,
      cssClass: 'alert_common',
      enableBackdropDismiss:false,
      buttons: [
        {
          text: this.translate.get('button_close')['value'],
          role: 'cancel',
        },
      ]
    });
    my_alert.present();
  }

  dispToast(message) {
    let toast = this.toastCtrl.create({
      message: message,
      position: 'middle',
      duration: 2000,
      cssClass: "toast_common",
    });
    toast.present();
  }

  getColor() {
    let color_list = {
      body_color:'#000000',
      body_background:'#ffffff',
      button_color:'#ffffff',
      button_background:'#4e8ef7',
      header_color:'#000000',
      header_background:'#4e8ef7',
      header_image:'',
      footer_color:'#ffffff',
      footer_inactive_color:'#b3b3b3',
      footer_background:'#4e8ef7',
    };

    if (localStorage.getItem('base_data') && localStorage.getItem('base_data') != '') {
      let base_data = JSON.parse(localStorage.getItem('base_data'));
      if (base_data['color']) {
        color_list['body_color'] = base_data['color'];
      }
      if (base_data['background_color']) {
        color_list['body_background'] = base_data['background_color'];
      }
      if (base_data['button_color']) {
        color_list['button_color'] = base_data['button_color'];
      }
      if (base_data['button_background_color']) {
        color_list['button_background'] = base_data['button_background_color'];
      }
    }

    if (localStorage.getItem('header_data') && localStorage.getItem('header_data') != '') {
      let header_data = JSON.parse(localStorage.getItem('header_data'));
      if (header_data['color']) {
        color_list['header_color'] = header_data['color'];
      }
      if (header_data['background_color']) {
        color_list['header_background'] = header_data['background_color'];
      }
      if (header_data['image']) {
        color_list['header_image'] = header_data['image'];
      }
    }

    if (localStorage.getItem('footer_color') && localStorage.getItem('footer_color') != '') {
      color_list['footer_color'] = localStorage.getItem('footer_color');
    }
    if (localStorage.getItem('footer_inactive_color') && localStorage.getItem('footer_inactive_color') != '') {
      color_list['footer_inactive_color'] = localStorage.getItem('footer_inactive_color');
    }
    if (localStorage.getItem('footer_background_color') && localStorage.getItem('footer_background_color') != '') {
      color_list['footer_background'] = localStorage.getItem('footer_background_color');
    }

    return color_list;
  }

  getHeaderData() {
    let header_data = [];
    if (localStorage.getItem('header_data') && localStorage.getItem('header_data') != '' && localStorage.getItem('header_data') != 'null') {
      header_data = JSON.parse(localStorage.getItem('header_data'));
    }
    return header_data;
  }

  getPcData() {
    let pc_data = [];
    if (localStorage.getItem('pc_data') && localStorage.getItem('pc_data') != '' && localStorage.getItem('pc_data') != 'null') {
      pc_data = JSON.parse(localStorage.getItem('pc_data'));
    }
    return pc_data;
  }

  getWordsData() {
    let words_data = [];
    if (localStorage.getItem('words_data') && localStorage.getItem('words_data') != '' && localStorage.getItem('words_data') != 'null') {
      words_data = JSON.parse(localStorage.getItem('words_data'));
    }
    return words_data;
  }

  getWordsValue(key, replace_flg=null) {
    let word = null;
    if (localStorage.getItem('words_data') && localStorage.getItem('words_data') != '' && localStorage.getItem('words_data') != 'null') {
      let words_data = JSON.parse(localStorage.getItem('words_data'));
      if (words_data[key]) {
        word = words_data[key];
        if (replace_flg) {
          word = word.replace(/\r?\n/g, '<br>');
        }
      }
    }
    return word;
  }

  getImagesValue(key) {
    let images_data = [];
    if (localStorage.getItem('images_data') && localStorage.getItem('images_data') != '' && localStorage.getItem('images_data') != 'null') {
      images_data = JSON.parse(localStorage.getItem('images_data'));
    }
    return images_data[key];
  }

  thumbnail(string, width) {
    let match_list = string.match(/http[s]?\:\/\/[\w\+\$\;\?\.\%\,\!\#\~\*\/\:\@\&\\\=\_\-]+/g);
    if (match_list) {
      for (let i=0; i<match_list.length; i++) {
        if(!match_list[i] || match_list[i] == ''){
          continue;
        }
        if (!match_list[i].match(/.jpg|.png|.gif|.jpeg/)) {
          continue;
        }
        if (match_list[i].match(/assets/)) {
          continue;
        }
        let img_url = this.getThumbnailUrl(match_list[i], width)
        string = string.replace(match_list[i], img_url);
      }
    }
    
    return string;
  }

  setHomeImage(home_body) {
    let tempEl = document.createElement('div');
    tempEl.innerHTML = home_body;
    let body_el = tempEl.firstElementChild;
    let rows_el = body_el.getElementsByClassName('shop-topmenu-row');
    let rss_ids = [];
    let slide_row_no = null;
    let home_iframe_url = null;
    let is_home_member_card = 0;
    let home_member_card_data = {};
    let home_coupon_column = null;
    let home_coupon_data = {};
    let home_event_column = null;
    let is_home_point = 0;
    let home_point_data = {};
    let is_home_mypage = 0;
    let home_mypage_logout = '';
    let home_mypage_login  = '';
    let is_home_score = 0;
    let home_score_data = {};
    
    if (rows_el) {
      for (let i = 0; i < rows_el.length; i++ ) {
        let row_el = rows_el[i];
        let width = 360;
        if (row_el.childElementCount == 2) {
          width = 540;
        } else if (row_el.childElementCount == 1) {
          width = 1080;
        }
        let imgs_el = row_el.getElementsByTagName('img');

        for (let j = 0; j < imgs_el.length; j++ ) {
          let img_el = imgs_el[j];
          if (img_el.src.match(/assets/)) {
            continue;
          }
          img_el.src = this.getThumbnailUrl(img_el.src, width);
        }


        // RSS
        let chk_rss_row = row_el.classList.contains('rss-row');
        if (chk_rss_row) {
          let rss_id = row_el.getAttribute('rss_id');
          if (rss_id) {
            rss_ids.push(rss_id);
          }
        }

        // スライド
        let chk_slide_row = row_el.classList.contains('slide-row');
        if (chk_slide_row) {
          slide_row_no = i + 1;
        }

        // iframe
        let chk_iframe_row = row_el.classList.contains('iframe-row');
        if (chk_iframe_row) {
          home_iframe_url = row_el.getAttribute('data-src');
        }

        // 会員証
        let chk_member_card_row = row_el.classList.contains('membershipcard-row');
        if (chk_member_card_row) {
          is_home_member_card = 1;
          home_member_card_data['background_color'] = row_el.getAttribute('background_color') ? row_el.getAttribute('background_color') : '#ffffff';
          home_member_card_data['background_image'] = row_el.getAttribute('background_image') ? row_el.getAttribute('background_image') : null;
          home_member_card_data['font_color']       = row_el.getAttribute('font_color') ? row_el.getAttribute('font_color') : '#000000';
          home_member_card_data['text']             = row_el.getAttribute('text') ? row_el.getAttribute('text') : null;
          home_member_card_data['shadow']           = row_el.getAttribute('shadow') ? row_el.getAttribute('shadow') : 'on';
          home_member_card_data['fixed']            = row_el.getAttribute('fixed') ? row_el.getAttribute('fixed') : 'off';
        }

        // クーポン
        let chk_coupon_row = row_el.classList.contains('coupon-row');
        if (chk_coupon_row) {
          home_coupon_column = row_el.getAttribute('column');
          home_coupon_data['column']        = row_el.getAttribute('column');
          home_coupon_data['title']         = row_el.getAttribute('title') ? row_el.getAttribute('title') : null;
          home_coupon_data['limit_display'] = row_el.getAttribute('limit_display') ? row_el.getAttribute('limit_display') : 'off';
        }

        // イベント
        let chk_event_row = row_el.classList.contains('event-row');
        if (chk_event_row) {
          home_event_column = row_el.getAttribute('column');
        }

        // ポイント
        let chk_point_row = row_el.classList.contains('point-row');
        if (chk_point_row) {
          is_home_point = 1;
          home_point_data['background_color'] = row_el.getAttribute('background_color') ? row_el.getAttribute('background_color') : '#ffffff';
          home_point_data['point_image']      = row_el.getAttribute('point_image');
          home_point_data['link_url']         = row_el.getAttribute('link_url') ? row_el.getAttribute('link_url') : null;
          home_point_data['shadow']           = row_el.getAttribute('shadow') ? row_el.getAttribute('shadow') : 'on';
        }

        // 会員情報
        let chk_mypage_row = row_el.classList.contains('mypage-row');
        if (chk_mypage_row) {
          is_home_mypage = 1;
          let logout_el = row_el.querySelector('.mypage-logout-row');
          if (logout_el) {
            home_mypage_logout = logout_el.innerHTML;
          }
          let login_el = row_el.querySelector('.mypage-login-row');
          if (login_el) {
            home_mypage_login = login_el.innerHTML;
          }
        }

        // スコア
        let chk_score_row = row_el.classList.contains('score-row');
        if (chk_score_row) {
          is_home_score = 1;
          home_score_data['target'] = row_el.getAttribute('target') ? row_el.getAttribute('target') : null;
        }
      }
      home_body = body_el.outerHTML;
    }

    localStorage.setItem('home_body', home_body);
    localStorage.setItem('home_rss_ids', JSON.stringify(rss_ids));
    this.setOptions('slide_row_no', slide_row_no);
    this.setOptions('home_iframe_url', home_iframe_url);
    this.setOptions('is_home_member_card', is_home_member_card);
    localStorage.setItem('home_member_card_data', JSON.stringify(home_member_card_data));
    this.setOptions('home_coupon_column', home_coupon_column);
    localStorage.setItem('home_coupon_data', JSON.stringify(home_coupon_data));
    this.setOptions('home_event_column', home_event_column);
    this.setOptions('is_home_point', is_home_point);
    localStorage.setItem('home_point_data', JSON.stringify(home_point_data));
    this.setOptions('is_home_mypage', is_home_mypage);
    localStorage.setItem('home_mypage_logout', home_mypage_logout);
    localStorage.setItem('home_mypage_login', home_mypage_login);
    this.setOptions('is_home_score', is_home_score);
    localStorage.setItem('home_score_data', JSON.stringify(home_score_data));
  }

  getThumbnailUrl(url, width) {
    if (url.indexOf('?src=') == -1) {
      return url;
    }
    let img_url = url + '&w=' + width;
    //let img_url = IMG_ENDPOINT + '/cache/?src=' + url;
    return img_url;
  }

  escapeHtml(string) {
    if(typeof string !== 'string') {
      return string;
    }
    return string.replace(/[&'`"<>]/g, function(match) {
      return {
        '&': '&amp;',
        "'": '&#x27;',
        '`': '&#x60;',
        '"': '&quot;',
        '<': '&lt;',
        '>': '&gt;',
      }[match]
    });
  }

  checkBarcodeFormat(barcode) {
    let card_data = this.getCardData();

    let is_format:boolean = false;
    let format = card_data['barcode_format'];
    //let format = localStorage.getItem('barcode_format');
    let format_list = {
      'CODE39':{'pattern':new RegExp(/^[0-9A-Z\-.$/\+%\*\s]*$/), 'message':'CODE39を入力してください。'},
      'CODE128':{'pattern':new RegExp(/^[\x00-\x7F]*$/), 'message':'CODE128を入力してください。'},
      'EAN13':{'pattern':new RegExp(/^\d{13}$/), 'message':'13桁の数値を入力してください。'},
      'EAN8':{'pattern':new RegExp(/^\d{8}$/), 'message':'8桁の数値を入力してください。'},
      'upc':{'pattern':new RegExp(/^\d{1,}$/), 'message':'数値を入力してください。'},
      'ITF14':{'pattern':new RegExp(/^\d{14}$/), 'message':'14桁の数値を入力してください。'},
      'codabar':{'pattern':new RegExp(/^[A-D0-9\+$:\-/.]*$/), 'message':'codabarを入力してください。'},
      //'codabar':{'pattern':new RegExp(/^[A-D][0-9\+$:\-/.]*[A-D]$/), 'message':'codabarを入力してください。'},
    };

    if (barcode && format && format_list[format]) {
      let result = barcode.match(format_list[format]['pattern']);
      if (result) {
        is_format = true;
      }
    }

    /*if (!is_format && is_message) {
      this.dispAlert(format_list[format]['message']);
    }*/
    return is_format;
  }

  addMonthlyRanking(data) {
    if (data['rank_number']) {
      data['rank_number_disp'] = data['rank_number'].toLocaleString();
      data['rank_number_color'] = '#ff0000';
    } else {
      data['rank_number_disp'] = '---';
      data['rank_number_color'] = '#000000';
    }

    if (data['score_total'] > 0) {
      data['score_total_disp'] = '+' + data['score_total'].toLocaleString();
      data['score_total_color'] = '#ff0000';
    } else if (data['score_total'] < 0) {
        data['score_total_disp'] = data['score_total'].toLocaleString();
        data['score_total_color'] = '#2995d0';
    } else {
      data['score_total_disp'] = 0;
      data['score_total_color'] = '#000000';
    }

    if (data['summary_score']) {
      data['summary_score_disp'] = data['summary_score'].toLocaleString();
    } else {
      data['summary_score_disp'] = '0';
    }

    return data;
  }

  checkExternal() {
    let user_data = this.getUser();
    if (!user_data['user_auth_key']) {
      return false;
    }

    let service_data = this.getService();
    if (!service_data['public_api_options']) {
      return false;
    }
    if (!service_data['public_api_options']['auth_api_url'] || !service_data['public_api_options']['reserve_page_url'] || !service_data['public_api_options']['regist_page_url']) {
      return false;
    }

    return true;
  }
  
  isTutorial() {
    let drawer_list = [];
    if (localStorage.getItem('drawer_list')) {
      drawer_list = JSON.parse(localStorage.getItem('drawer_list'));
    }

    let find_tutorial = drawer_list.find((value) => {
      return (value['page_target'] == 'TutorialIndexPage' && !value['is_privated']);
    });

    if (find_tutorial) {
      return true;
    }
    return false;
  }

  getRgba(hex, alpha=1) {
    hex = hex.replace(/^#/, '');
  
    if (hex.length === 3) {
      hex = hex.split('').map(x => x + x).join('');
    }
  
    // RGB値を取得
    let bigint = parseInt(hex, 16);
    let r = (bigint >> 16) & 255;
    let g = (bigint >> 8) & 255;
    let b = bigint & 255;
  
    return `rgb(${r}, ${g}, ${b}, ${alpha})`;
  }

  getInheritMail() {
    let service_data = this.getService();
    let user_data = this.getUser();

    let subject = '【' + service_data['name'] + '】引継ぎ情報';
    let body = '機種変更などの際にアカウントを引き継ぐには、ユーザーID及び引継ぎコードが必要になります。';
    body += '%0D%0A本メールをご自身のメールアドレスに送付頂き、大切に保管くださいますようお願いします。';
    body += '%0D%0A-------------------------';
    body += '%0D%0AユーザーID：' + user_data['id'];
    body += '%0D%0A引継ぎコード：' + user_data['pin_code'];
    body += '%0D%0A-------------------------';

    let mailto = 'mailto:?subject=' + subject + '&body=' + body;

    return mailto;
  }
}


// WEBPACK FOOTER //
// ./src/providers/common/common.ts